import { render } from "./CalculationResult.vue?vue&type=template&id=5ac70a06"
import script from "./CalculationResult.vue?vue&type=script&lang=js"
export * from "./CalculationResult.vue?vue&type=script&lang=js"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__